


// document.addEventListener("DOMContentLoaded", () => {
//   // Desktop only
//   if (window.innerWidth < 1200) return;

//   const thumbnails = document.querySelectorAll(
//     ".product-media__grid-column--scrollable [data-media-id]"
//   );

//   const mainImages = document.querySelectorAll(
//     ".product-media__grid-column--sticky [data-media-id]"
//   );

//   if (!thumbnails.length || !mainImages.length) return;

//   /* -----------------------------
//      CLICK THUMBNAIL → SCROLL
//   ----------------------------- */
//   thumbnails.forEach((thumb) => {
//     thumb.addEventListener("click", () => {
//       const mediaId = thumb.dataset.mediaId;
//       const target = document.getElementById(`media-${mediaId}`);

//       if (!target) return;

//       target.scrollIntoView({
//         behavior: "smooth",
//         block: "center",
//       });
//     });
//   });

//   /* --------------------------------
//      SCROLL → ACTIVE THUMBNAIL
//   -------------------------------- */
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (!entry.isIntersecting) return;

//         const mediaId = entry.target.dataset.mediaId;

//         thumbnails.forEach((thumb) => {
//           thumb.classList.toggle(
//             "is-active",
//             thumb.dataset.mediaId === mediaId
//           );
//         });
//       });
//     },
//     {
//       rootMargin: "-40% 0px -40% 0px",
//       threshold: 0,
//     }
//   );

//   mainImages.forEach((image) => observer.observe(image));
// });




// new code to work for product thumbnail in desktop without getting affected by mobile responsiveness of carousel below title,price,reviews 


(() => {
  let initialized = false;
  let observer = null;

  function initDesktopGallery() {
    // Desktop only
    if (window.innerWidth < 1200) return;
    if (initialized) return;

    const thumbnails = document.querySelectorAll(
      ".product-media__grid-column--scrollable [data-media-id]"
    );

    const mainImages = document.querySelectorAll(
      ".product-media__grid-column--sticky [data-media-id]"
    );

    if (!thumbnails.length || !mainImages.length) return;

    /* -----------------------------
       CLICK THUMBNAIL → SCROLL
    ----------------------------- */
    thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const mediaId = thumb.dataset.mediaId;
        const target = document.getElementById(`media-${mediaId}`);
        if (!target) return;

        target.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    });

    /* --------------------------------
       SCROLL → ACTIVE THUMBNAIL
    -------------------------------- */
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const mediaId = entry.target.dataset.mediaId;

          thumbnails.forEach((thumb) => {
            thumb.classList.toggle(
              "is-active",
              thumb.dataset.mediaId === mediaId
            );
          });
        });
      },
      {
        rootMargin: "-40% 0px -40% 0px",
        threshold: 0,
      }
    );

    mainImages.forEach((image) => observer.observe(image));

    initialized = true;
  }

  function destroyDesktopGallery() {
    if (!observer) return;
    observer.disconnect();
    observer = null;
    initialized = false;
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", initDesktopGallery);

  // Re-evaluate on resize
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 1200) {
      initDesktopGallery();
    } else {
      destroyDesktopGallery();
    }
  });
})();
